<template>
  <div class="row-fluid">
    <div class="my-0 section-shaped">
      <div class="row">
        <div class="col-md-2">&nbsp;</div>
        <div v-if="alertDetails.display" class="col-md-6" style="padding-top: 5px">
          <b-alert v-model="alertDetails.display" :variant="alertDetails.type" show dismissible>
            {{ alertDetails.message }}
          </b-alert>
        </div>
      </div>
      <div class="shape shape-style-1 shape-default"></div>

      <div class="container pb-lg">
        <div class="row justify-content-between align-items-center">
          <div class="col-lg-5 mb-5 mb-lg-0">
            <h1 class="text-white font-weight-light">Welcome to Umbai Africa</h1>
            <div class="lead text-white mt-4">
              <p>Your one-stop solution for cross border airtime, data, and bill payment for <strong>Zimbabwe</strong>,
                <strong>Malawi</strong> and <strong>South Africa</strong>
              </p>
              <b-row>
                <b-col>
                  <router-link to="/login">
                    <base-button variant="outline-primary">Login </base-button>
                  </router-link>
                  &nbsp;
                  <router-link to="/register">
                    <base-button type="white">Register</base-button>
                  </router-link>
                </b-col>

              </b-row>
            </div>

          </div>
          <div class="col-lg-6 mb-lg-auto">
            <div class="rounded shadow-lg overflow-hidden transform-perspective-right">
              <b-carousel id="carousel1" controls indicators>
                <b-carousel-slide img-src="land/land1.jpg"></b-carousel-slide>
                <b-carousel-slide img-src="land/land2.jpg"></b-carousel-slide>
              </b-carousel>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { BCarousel } from "bootstrap-vue/esm/components/carousel/carousel";
import { BCarouselSlide } from "bootstrap-vue/esm/components/carousel/carousel-slide";
import { BAlert } from "bootstrap-vue/esm/components/alert/alert";
import config from "@/settings/config.js";
import * as signalR from "@aspnet/signalr";

export default {
  name: "components",
  components: {
    BCarousel,
    BCarouselSlide,
    BAlert,
  },
  data: () => ({
    connection: new signalR.HubConnectionBuilder()
      .withUrl(`${config.gateway}hub/signalr`)
      .build(),
    alertDetails: {
      type: "info",
      message: "recharge done",
      display: true,
    },
  }),
  mounted() {
    this.alertMessage();
    this.$store.dispatch("alertmessage/Reset");
    this.registerClient();
    this.getNotified();
  },

  methods: {
    getNotified() {
      this.connection.on(
        "SendNotification",
        (receiverMobile, message, createdOn) => {
          this.alertDetails.display = true;
          this.alertDetails.message =
            message + " View Inbox for more information.";
          this.alertDetails.type = "success";
        }
      );
    },
    registerClient() {
      const user = this.$store.getters["login/user"];
      if (user) {
        let username = user.profile.email;
        if (user.username) username = user.username;
        if (this.connection.state === signalR.HubConnectionState.Connected) {
          this.connection.invoke("RegisterClient", username);
        } else {
          this.connection
            .start()
            .then(() => this.connection.invoke("RegisterClient", username));
        }
      }
    },
    alertMessage() {
      let alertDetails = this.$store.getters["alertmessage/AlertDetails"];
      this.alertDetails.display = alertDetails.display;
      this.alertDetails.message = alertDetails.msg;
      this.alertDetails.type = alertDetails.type;
    },
  },
};
</script>
